import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import DesktopIcon from "./DesktopIcon";
import TopMenuBar from "./TopMenuBar";
import BottomDock from "./BottomDock";
import AppWindow from "./AppWindow";
import IntroApp from "./IntroApp";
import TomNookApp from "./TomNookApp";
import WorkExperienceApp from "./WorkExperienceApp";
import ProjectsApp from "./ProjectsApp";
import EducationApp from "./EducationApp";
import ContactApp from "./ContactApp";
import ClubsApp from "./ClubsApp";
import AboutMeApp from "./AboutMeApp";
import workExperienceIcon from "./assets/briefcase.png";
import githubIcon from "./assets/book.png";
import educationIcon from "./assets/school.png";
import contactIcon from "./assets/nookphone.png";
import aboutMeIcon from "./assets/kennycropped.png";
import clubsIcon from "./assets/notebook.png";

function App() {
  const [openApp, setOpenApp] = useState(null);
  const [isScreenTooSmall, setIsScreenTooSmall] = useState(false);
  const elementRef = useRef(null);

  const handleIconClick = (appName) => {
    setOpenApp(appName);
  };

  const closeApp = () => {
    setOpenApp(null);
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsScreenTooSmall(window.innerWidth < 1080 || window.innerHeight < 720);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    const element = elementRef.current;
    const text = "Hello, my name is Kenny Thai!";
    let index = 0;

    element.innerHTML = '<span class="text-content"></span>';
    const textContent = element.querySelector(".text-content");

    function typeWriter() {
      if (index < text.length) {
        textContent.innerHTML += text.charAt(index);
        index++;
        setTimeout(typeWriter, 100);
      } else {
        setTimeout(() => {
          index = 0;
          textContent.innerHTML = "";
          typeWriter();
        }, 1000);
      }
    }

    typeWriter();
  }, []);

  return (
    <>
      <TopMenuBar />
      <div className="desktop">
        <section className="stage">
          <figure className="ball bubble">
            <span className="shadow"></span>
          </figure>
          <div className="sphere_text" ref={elementRef}></div>
          <div className="scroll-message">
            ← Click the left apps to learn more ←
          </div>
        </section>
        <div className="desktop-icons">
          <DesktopIcon
            iconSrc={aboutMeIcon}
            label="About Me"
            onClick={() => handleIconClick("About Me")}
          />
          <DesktopIcon
            iconSrc={workExperienceIcon}
            label="Work Experience"
            onClick={() => handleIconClick("Work Experience")}
          />
          <DesktopIcon
            iconSrc={githubIcon}
            label="Projects"
            onClick={() => handleIconClick("Github")}
          />
          <DesktopIcon
            iconSrc={educationIcon}
            label="Education"
            onClick={() => handleIconClick("Education")}
          />
          <DesktopIcon
            iconSrc={clubsIcon}
            label="Clubs"
            onClick={() => handleIconClick("Clubs")}
          />
          <DesktopIcon
            iconSrc={contactIcon}
            label="Contact"
            onClick={() => handleIconClick("Email")}
          />
        </div>
      </div>
      <BottomDock onDockClick={() => handleIconClick("TomNook")} />

      {/* Modal Windows */}
      <AppWindow
        isOpen={openApp === "Intro"}
        onClose={closeApp}
        title=""
        width={600}
        height={400}
        noScroll={true}
      >
        <IntroApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "Work Experience"}
        onClose={closeApp}
        title=""
        width={900}
        height={700}
      >
        <WorkExperienceApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "Github"}
        onClose={closeApp}
        title=""
        width={1000}
        height={700}
      >
        <ProjectsApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "Education"}
        onClose={closeApp}
        title=""
        width={1100}
        height={750}
      >
        <EducationApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "Email"}
        onClose={closeApp}
        title=""
        width={950}
        height={600}
      >
        <ContactApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "Clubs"}
        onClose={closeApp}
        title=""
        width={900}
        height={700}
      >
        <ClubsApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "About Me"}
        onClose={closeApp}
        title=""
        width={1100}
        height={700}
      >
        <AboutMeApp />
      </AppWindow>

      <AppWindow
        isOpen={openApp === "TomNook"}
        onClose={closeApp}
        title=""
        width={600}
        height={400}
        noScroll={true}
      >
        <TomNookApp />
      </AppWindow>

      <AppWindow
        isOpen={isScreenTooSmall}
        onClose={() => {}}
        title=""
        width={600}
        height={400}
        noScroll={true}
      >
        <TomNookApp message="Hm? Tom Nook here. This screen size isn't supported yet, yes yes. Switch to desktop for the full experience!" />
      </AppWindow>
    </>
  );
}

export default App;
